import { DataBean } from "../DataBean";

export class AcademicEducation extends DataBean {


    public async getAcademicEducationAccountCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("TalentERP", "java.util.List_getAcademicEducationAccountCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

     public async getAcademicEducationAccountReport(page:any,Rows:any,props:any): Promise<any> {
        return this.getCustomService("TalentERP", "com.advantage.shared.Report_getAcademicEducationAccountReport_Number_Number_java.util.Map", [page,Rows,props]);
    }

}